import { config } from "@/config";
// The blog registry: newest first. Adding a post = one entry here, a body
// module in content/blog/posts/, and a page file in src/pages/blog/.
import type { BlogPostMeta } from "./types";

export const BLOG_POSTS = [
  {
    slug: "engineering-behind-matic-serene",
    title: "The engineering behind Matic Serene's smoother sound",
    subtitle:
      "How we redesigned Matic's vacuum stack to make an already quiet robot sound even better.",
    publishedAt: "2026-10-27T08:00-07:00",
    author: "The Matic Team",
    isFeatured: false,
    headerMedia:
      "/images/blog/engineering-behind-matic-serene/serene-limited-edition-plate.webp",
    ogImage: {
      path: "/images/blog/engineering-behind-matic-serene/serene-limited-edition-plate-og.jpg",
      width: 1200,
      height: 675,
    },
    metaDescription:
      "Discover how Matic's engineers redesigned the vacuum stack to reduce high-frequency noise and create a softer, smoother sound without compromising cleaning performance.",
  },
  {
    slug: "why-where-your-home-robot-is-built-matters",
    title: "Why where your home robot is built matters",
    seoTitle: "FCC Robot Vacuum Rules: Why Matic Received Conditional Approval",
    publishedAt: "2026-10-07T08:00-07:00",
    author: "The Matic Team",
    isFeatured: false,
    headerMedia:
      "/images/blog/why-where-your-home-robot-is-built-matters/matic-assembly-mountain-view.webp",
    metaDescription:
      "Matic is the first robot vacuum to receive conditional FCC approval under new restrictions on certain foreign-made connected devices. Learn what the rules mean and why Matic assembles every robot in California.",
  },
  {
    slug: "twice-the-intelligence-still-nothing-leaves-your-home",
    title: "Twice the Intelligence. Still Nothing Leaves Your Home.",
    publishedAt: "2026-08-25T08:00-07:00",
    author: "Navneet Dalal, CEO and Co-founder",
    isFeatured: false,
    headerMedia:
      "/images/blog/twice-the-intelligence-still-nothing-leaves-your-home/matic-jetson-compute-module.jpg",
    metaDescription:
      "Why Matic is among the first to build on NVIDIA Jetson Orin Nano 2. This morning NVIDIA announced Jetson Orin Nano 2, a new robotics computer for\u2026",
  },
  {
    slug: "how-your-voice-data-is-handled",
    title: "How does Matic Cues voice & gesture control handle my data?",
    publishedAt: "2026-08-13T11:00-07:00",
    author: "Amy Mathews",
    isFeatured: false,
    headerMedia: "/images/blog/how-your-voice-data-is-handled/Blog_Banner.png",
    metaDescription:
      "Like everything we do, Matic Cues was engineered with a privacy-first approach, and as always, you have complete control. With Matic Cues, Matic now…",
  },
  {
    slug: "matic-release-notes",
    title: "Matic Release Notes",
    publishedAt: "2026-11-02T00:00-08:00",
    author: "Amy Mathews",
    isFeatured: false,
    headerMedia: "/images/blog/matic-release-notes/matic-software-updates.jpg",
    thumbnail:
      "/images/blog/matic-release-notes/matic-software-updates-thumbnail.jpg",
    metaDescription:
      'Stable 181 2026/10/26: Software Updates: Trick or Treat: Through November 1, say "Hey Matic, trick or treat" and Matic answers with a Halloween trick or treat…',
  },
  {
    slug: "the-robot-that-understands-your-family",
    title: "The Robot That Understands Your Family",
    publishedAt: "2026-08-12T00:00-07:00",
    author: "Vibha Vasanth",
    isFeatured: true,
    headerMedia:
      "/images/blog/the-robot-that-understands-your-family/Frame_2036086088.png",
    metaDescription:
      "Stable 182 2026/11/02: Software Updates: Quieter Mopping: Matic now accelerates more gently while mopping, reducing wheel slip and the squeaking it can cause…",
  },
  {
    slug: "privacy-isnt-a-feature-its-why-we-built-matic",
    title: "Privacy Isn't a Feature. It's Why We Built Matic.",
    publishedAt: "2026-03-05T19:27-08:00",
    author: "The Matic Team",
    headerMedia:
      "/images/blog/privacy-isnt-a-feature-its-why-we-built-matic/Screenshot_2026-03-04_at_4.26.33_PM.png",
    metaDescription:
      "When you bring technology into your home, do you know who else you're letting in? A few days ago, a software engineer tried to build a custom app to…",
  },
  {
    slug: "the-usd60-million-bet-that-what-comes-after-roomba-is-matic",
    title: "The $60 Million Bet That What Comes After Roomba is…Matic. ",
    publishedAt: "2026-01-29T00:00-08:00",
    author: "Navneet Dalal ",
    isFeatured: true,
    headerMedia:
      "/images/blog/the-usd60-million-bet-that-what-comes-after-roomba-is-matic/Screenshot_2026-01-28_at_5.01.12_PM.png",
    metaDescription:
      "Today we're announcing $60 million in new funding to scale Matic. We didn't raise this on a vision of what might be possible someday. It is an outcome of…",
  },
  {
    slug: "ask-me-anything-matic-hardware-design",
    title: "AMA with Head of Hardware on Design, Innovation & User Experience",
    publishedAt: "2025-05-16T00:00-07:00",
    author: "Anshuman Kumar",
    isFeatured: false,
    headerMedia:
      "/images/blog/ask-me-anything-matic-hardware-design/Anshuman-AMA.jpg",
    metaDescription:
      "Robot vacuums have been around for over two decades, but most still fall short in the same familiar ways. They’re loud. They get tangled up in cords…",
  },
  {
    slug: "matic-robot-vacuum-hepa-bag-2",
    title:
      "The Science Behind Matic’s HEPA-12 Bag: Smarter Cleaning and Reimagined Vacuum Hygiene",
    publishedAt: "2025-05-05T00:00-07:00",
    author: "Karthik Chandrashekaraiah",
    isFeatured: false,
    headerMedia: "/images/blog/matic-robot-vacuum-hepa-bag-2/HEPA-BAGs.png",
    metaDescription:
      "Your Vacuum’s Filter Matters More Than You Think When was the last time you replaced your robot vacuum’s filter? If you’re not sure, you’re not alone…",
  },
  {
    slug: "vision-first-robotics-how-matic-is-reimagining-home-automation",
    title:
      "Inside Matic's 7-Year Journey To Create Vision-Only Robots That See the World Like Humans",
    publishedAt: "2025-04-02T00:00-07:00",
    author: "Lexie Ma",
    isFeatured: false,
    headerMedia:
      "/images/blog/vision-first-robotics-how-matic-is-reimagining-home-automation/AMA_Mehul.png",
    metaDescription:
      "In a world where disc-shaped robot vacuums still stumble through homes, blindly bumping into furniture and struggling to not get tangled up by wires…",
  },
  {
    slug: "matic-maintenance-and-care",
    title: "Matic Care and Maintenance Guide",
    subtitle: "A little care keeps Matic (and your floors) in great shape",
    publishedAt: "2025-03-13T00:00-07:00",
    updatedAt: "2026-10-08T00:00-07:00",
    author: "Marie Goerger",
    isFeatured: false,
    headerMedia:
      "/images/blog/matic-maintenance-and-care/Matic-care-and-maintenance-guide.png",
    metaDescription:
      "A simple guide to caring for your Matic: what to do each month, every few months, and when Matic prompts you, with how-to videos along the way.",
  },
  {
    slug: "the-magic-behind-matics-mopping",
    title: "The Magic Behind Matic’s Mopping",
    publishedAt: "2025-01-27T00:00-07:00",
    author: "Anshuman Kumar",
    isFeatured: true,
    headerMedia: "/images/blog/the-magic-behind-matics-mopping/DSCF8968-1.jpg",
    metaDescription:
      "Imagine waking up on a peaceful Sunday morning. The house is quiet, the kids are still asleep, and you're looking forward to a relaxing day. But the…",
  },
  {
    slug: "why-matic-brushroll-is-different",
    title:
      "Why Matic's Brushroll Is Different — And Why It Matters For Your Floors",
    publishedAt: "2025-01-08T00:00-07:00",
    author: "Anshuman Kumar",
    isFeatured: false,
    thumbnail: "/images/blog/why-matic-brushroll-is-different/VacuumFlaps.png",
    metaDescription:
      "Cleaning your floors can often feel like a constant trade-off. You want a vacuum that’s thorough, but not so aggressive that it bumps everywhere and…",
  },
  {
    slug: "why-matic-is-the-most-private-and-secure-robot-vacuum",
    title:
      "Matic — The World’s First Robot Vacuum and Mop Reimagined to Defend Privacy of Your Home",
    publishedAt: "2024-09-05T00:00-07:00",
    author: "Lexie Ma",
    isFeatured: true,
    thumbnail:
      "/images/blog/why-matic-is-the-most-private-and-secure-robot-vacuum/reviews.png",
    metaDescription:
      "Homes are our sanctuary. We put so much effort into making sure they are loving, nurturing, and peaceful. Home is where we build memories, express…",
  },
  {
    slug: "the-ultimate-fathers-day-gift-idea-for-tech-savvy-dads",
    title:
      "The Ultimate Father’s Day Gift Idea for Tech-Savvy Dads: Matic, the AI-Powered Robot Vacuum",
    publishedAt: "2024-06-05T00:00-07:00",
    author: "Lexie Ma",
    isFeatured: false,
    headerMedia:
      "/images/blog/the-ultimate-fathers-day-gift-idea-for-tech-savvy-dads/founders.webp",
    metaDescription:
      "Father's Day is just around the corner, and if you're scratching your head over the perfect gift for the tech-savvy dad in your life, we've got the…",
  },
  {
    slug: "the-design",
    title: "Reimagining Home Cleaning with Matic: The Design",
    publishedAt: "2024-05-29T00:00-07:00",
    author: "Lexie Ma",
    isFeatured: false,
    thumbnail: "/images/blog/the-design/Matic-Exloded-Render.jpeg",
    metaDescription:
      "While there are over 250 self-driving car startups and numerous companies solving industrial robotics challenges, very few are focusing on bringing…",
  },
  {
    slug: "why-rust-its-the-safe-choice",
    title: "Why Rust? It's the safe choice.",
    publishedAt: "2024-02-13T00:00-07:00",
    author: "Eric Seppanen",
    isFeatured: false,
    headerMedia: "/images/blog/why-rust-its-the-safe-choice/PCB.jpg",
    metaDescription:
      "At Matic Robots, we're building an intelligent robot with advanced hardware and software features. One of the things that helps is writing our code in…",
  },
  {
    slug: "matic-comes-out-of-stealth-with-30m-in-funding",
    title:
      "Matic comes out of stealth with $30M in funding to launch fully autonomous indoor robots",
    publishedAt: "2023-11-02T00:00-07:00",
    author: "Navneet Dalal, Co-Founder & CEO",
    isFeatured: false,
    headerMedia: `${config.media.baseUrl}/videos/blog/matic-comes-out-of-stealth-with-30m-in-funding/matic-demo-360-modal-video.mp4`,
    metaDescription:
      "Autonomous technology is here. Robotaxis are shuttling around thousands of people every day in San Francisco. You’d think that the so-called “smart…",
  },
] as const satisfies readonly BlogPostMeta[];

export type BlogSlug = (typeof BLOG_POSTS)[number]["slug"];

export const formatPostDate = (dateString: string): string =>
  new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

export const postsNewestFirst = (
  posts: readonly BlogPostMeta[],
): BlogPostMeta[] =>
  [...posts].sort(
    (a, b) =>
      new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );

export function getPostMeta(slug: BlogSlug): BlogPostMeta {
  const meta = BLOG_POSTS.find((post) => post.slug === slug);
  if (!meta) {
    throw new Error(`Unknown blog post slug: ${slug}`);
  }
  return meta;
}
